import CciNavigationBar from 'components/ccinavigationbar/CciNavigationBar.vue'
import CciSectionsBar from 'components/ccisectionsbar/CciSectionsBar.vue'
const CciScrubber = () => import(/* webpackPrefetch: true */ 'components/cciscrubber/CciScrubber.vue')
const CciIssueOverview = () => import('components/cciissueoverview/CciIssueOverview.vue')
const CciArticleModal = () => import(/* webpackPrefetch: true */ 'components/cciarticlemodal/CciArticleModal.vue')
const CciSocialSharing = () => import('components/ccisocialsharing/CciSocialSharing.vue')
const CciImageGalleryModal = () => import('components/cciimagegallerymodal/CciImageGalleryModal.vue')
import { CciDataSource, CciDataSourceClearMemory, sections, articles, pages, singlePages, issueName, publicationName, newsRoomName, zoneName, interstitialsFrequency, interstitials, stylesheetRef } from 'model/CciDataSource.js'
import { mapGetters } from 'vuex'
import Vue from 'vue'
// import GATrackingModule from './tracking/GATrackingModule'
import GTMTrackingModule from './tracking/GTMTrackingModule'
import FirebaseTrackingModule from './tracking/FirebaseTrackingModule'
import WindowTrackingModule from './tracking/WindowTrackingModule'
import CciGoogleAdBottomMobile from 'components/ccigoogleads/CciGoogleAdBottomMobile.vue'
import CciGoogleAdSide from 'components/ccigoogleads/CciGoogleAdSide.vue'
const CciRightAlignedNavigationBar = () => import('components/ccirightalignednavigationbar/CciRightAlignedNavigationBar.vue')
const CciLeftAlignedScrubber = () => import('components/ccileftalignedscrubber/CciLeftAlignedScrubber.vue')
import i18n from './lang/i18n'

export default {
  name: 'app',
  data () {
    return {
      isNIE: false,
      isZoomed: false
    }
  },
  created () {
    window.addEventListener("orientationchange", this.orientationDidChange)

    var cciobjectsUrl = this.opsUrl + 'cciobjects.json'

    if (this.token !== undefined) {
      cciobjectsUrl = this.opsUrl + 'cciobjects.json' + "?token=" + this.token
    }

    let settingsPath
    if (process.env.NODE_ENV === 'development') {
      settingsPath = '../static/settings.json'
    } else {
      settingsPath = './static/settings.json'
    }

    let urlGETFullIssue = this.opsUrl
    urlGETFullIssue = urlGETFullIssue.substr(0, urlGETFullIssue.lastIndexOf('/'))
    urlGETFullIssue = urlGETFullIssue.substr(0, urlGETFullIssue.lastIndexOf('/'))

    this.requestUrlTest(urlGETFullIssue + '/pagespdffull').then((isValid) => {
      this.$store.state.hasGETFullIssue = isValid
    })

    this.requestUrlTest(this.getAudioMp3UrlEndpoint(), true).then((isValid) => {
      this.$store.state.hasTtsService = isValid
    })

    if (this.opsUrl === '') {
      this.loadSettingsForTrackingTest(settingsPath)
      this.$router.push({ name: 'error' })
      return
    }
    this.$http.get(settingsPath).then((response) => {
      return response.json()
    }).then((settingsJson) => {
      this.$http.get(cciobjectsUrl).then((response) => {
        let entitlementsHeader = response.headers.get('entitlements')
        this.parseEntitlementsHeader(entitlementsHeader)
        return response.json()
      }).then((json) => {
        // this.$store.commit('setDataJson', json)
        // let width = document.documentElement.clientWidth
        // let height = document.documentElement.clientHeight

        // let testEntitlements = ['nie', 'eedition']
        // this.$store.state.entitlements = testEntitlements
        let gptAdCode = this.getSettingValueFromKey(settingsJson, 'gptAdCode')
        let isFullPageViewMode = this.getSettingValueFromKey(settingsJson, 'isFullPageViewMode')
        let enableZoomToAds = this.getSettingValueFromKey(settingsJson, 'enableZoomToAds')
        let enableZoomToTables = this.getSettingValueFromKey(settingsJson, 'enableZoomToTables')
        this.isNIE = this.$store.state.entitlements.includes('nie')
        let includeAds = !this.$store.state.entitlements.includes('no-ads') && !this.$store.state.entitlements.includes('nie') && gptAdCode !== undefined && gptAdCode !== ''

        this.$store.commit('setArticleViewMode', this.getSettingValueFromKey(settingsJson, 'articleViewModeDefault'))

        let isSinglePages = this.isPhone() || (this.isTabletPortrait() && !includeAds) || this.isPortrait()
        CciDataSource(json, isSinglePages, this.$store.state.entitlements, /*includeAds,*/ isFullPageViewMode, enableZoomToAds, enableZoomToTables)
        this.parseSettings(settingsJson, issueName, newsRoomName, publicationName, zoneName)

        var singlePage = pages[this.getIndexForPageFromRouteParam(this.startPage)]
        // if (singlePage === undefined) {
        //   singlePage = pages[0]
        // }

        // var singlePage = singlePages[parseInt(this.startPage - 1)]
        // if (singlePage === undefined) {
        //   singlePage = singlePages[0]
        // }

        if (this.settings !== undefined) {
          window.document.title = this.settings.windowTitle
          i18n.locale = this.settings.defaultLocale
          this.$store.commit('setPageViewMode', isFullPageViewMode)
        }

        this.$store.state.publicationName = publicationName
        this.$store.state.pubDateDate = json.attributes.PubDateDate
        this.$store.state.zoneCont = json.attributes.ZoneCont
        this.$store.state.editionCont = json.attributes.EditionCont
        this.$store.state.issueInternalId = json.id
        this.$store.state.issueInternalName = json.attributes.Name
        this.$store.state.issueName = issueName

        this.$store.commit('setPages', pages)
        this.$store.commit('setSinglePagesNoAds', singlePages)
        this.$store.commit('setSections', sections)
        this.$store.commit('setArticles', articles)
        if (singlePage !== undefined) {
          this.$store.commit('setCurrentPage', singlePage)
        }
        this.$store.commit('setInterstitialsFrequency', interstitialsFrequency)
        this.$store.commit('setInterstitials', interstitials)
        this.$store.commit('setAdsEnabled', includeAds)

        CciDataSourceClearMemory()

        this.setFontSizeFromStylesheet()

        // If the app is opened without a route name specified in the url, then navigate to pages.
        // console.log(this.$route.name)
        // if (this.$route.name === null) {
        //   this.$store.commit('setCurrentArticle', articles[0])
        //   this.$router.push({ name: 'pages', params: { pageNr: singlePage.pageNumber }})
        // }

        if (this.isPhone() && (this.$route.name === 'articles-mobile' || this.$route.name === 'article-mobile')) {
          document.getElementById('app').style.overflow = 'auto'
        }

        if (this.isPhone() && this.$route.name === 'articles-mobile') {
          this.$store.commit('setCurrentArticle', this.$store.state.articles[0])
          this.$store.commit('setCurrentPage', this.$store.state.articles[0].page)
        }
          // If the app is opened with direct link to an article.
        if (this.$route.name === 'article-mobile' || this.$route.name === 'articles') {
          this.navigateToArticleList()
        }

        // if (this.$route.name === 'articles-mobile' && !this.isPhone()) {
        //   this.$router.push({ name: 'articles', params: { articleNr: '0' } })
        // }

        if (this.settings.trackingScripts.length > 0) {
          let scriptsArr = this.settings.trackingScripts
          for (var i = 0; i < scriptsArr.length; i++) {
            var head = document.getElementsByTagName('head')[0]
            var script = document.createElement('script')
            script.type = 'text/javascript'
            script.src = scriptsArr[i]
            head.appendChild(script)
          }
        }

        if (this.settings.tracking && this.settings.tracking.modules) {
          let modules = this.settings.tracking.modules
          for (var j = 0; j < modules.length; j++) {
            if (modules[j].module) {
              const trackingModule = this.createTrackingModule(modules[j])
              if (trackingModule) {
                Vue.cciEventTrackingPlugin.setEventTrackingModule(trackingModule)
              }
            }
          }
        }
      }).catch((response) => {
        console.log('ERROR', response)
        let reDirect = response.headers.get('re-direct-paywall')
        if (reDirect !== undefined && reDirect !== null && reDirect === 'true') {
          let paywallUrl = this.getSettingValueFromKey(settingsJson, 'paywallUrl')
          if (paywallUrl !== undefined && paywallUrl !== "") {
            window.location.href = paywallUrl
          }
        } else {
          this.$store.commit('setErrorMessage', response.statusText)
          this.$router.push({ name: 'error' })
        }
      })
    }).catch((response) => {
      console.log('ERROR', response)
      this.$store.commit('setErrorMessage', response.statusText)
      this.$router.push({ name: 'error' })
    })
  },
  computed: {
    showSectionsBar: function () {
      return (this.settings !== undefined && this.settings.enableSectionsBar) &&
      this.sections.length > 1 &&
      this.$route.name !== 'articles-mobile' &&
      this.$route.name !== 'article-mobile' &&
      this.$route.name !== 'articles'
    },
    showGptAdModuleBottom: function () {
      return this.$route.name === 'pages' &&
      this.adsEnabled &&
      this.initPageLoaded &&
      !this.isDesktop()
    },
    showGptAdModuleSide: function () {
      // load the ad on the left after the first page has loaded.
      return this.$route.name === 'pages' &&
      this.adsEnabled &&
      this.initPageLoaded &&
      this.isDesktop()
    },
    isVerticalLayout: function () {
      return this.settings !== undefined && this.settings.enableVerticalLayout
    },
    showRightAlignedBar () {
      if (this.settings !== undefined && this.settings.enableVerticalLayout && !this.showImageGalleryModal) {
        if (this.isDesktop() || this.isTabletLandscape()) {
          return true
        } else if (this.isPhone()) {
          if (this.isZoomed) {
            return this.showArticleModal
          }
          return true
        } else if (this.isTabletPortrait()) {
          if (this.isZoomed) {
            return false
          }
          return !this.showArticleModal
        }
      }
      return false
    },
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      showScrubber: 'getShowScrubber',
      showIssueOverview: 'getShowIssueOverview',
      printAndDownload: 'getPrintAndDownload',
      showArticleModal: 'getShowArticleModal',
      showSharing: 'getShowSharing',
      showImageGalleryModal: 'getShowImageGalleryModal',
      showCrop: 'getShowCrop',
      showRightAlignedNavigationBar: 'getShowRightAlignedNavigationBar',
      currentPage: 'getCurrentPage',
      currentArticle: 'getCurrentArticle',
      startPage: 'getStartPage',
      settings: 'getSettings',
      sections: 'getSections',
      isZoomAnimating: 'getIsZoomAnimating',
      token: 'getToken',
      entitlements: 'getEntitlements',
      adsEnabled: 'getAdsEnabled',
      initPageLoaded: 'getInitPageLoaded',
      zoomedPages: 'getZoomedPages'
    })
  },
  watch: {
    zoomedPages (newValue) {
      this.isZoomed = newValue.indexOf(this.currentPage) !== -1
    }
  },
  methods: {
    parseSettings (settingsJson, issueName, newsRoomName, publicationName, zoneName) {
      var settings = settingsJson
      var nieSettings = {}
      if (this.isNIE) {
        nieSettings = this.getNIESettings(settings)
      }
      if (settingsJson.newsRooms !== undefined) {
        for (let i = 0; i < settingsJson.newsRooms.length; i++) {
          var newsRoom = settingsJson.newsRooms[i]
          if (newsRoom.newsRoomName === newsRoomName) {
            for (let key in settingsJson) {
              if (Object.prototype.hasOwnProperty.call(newsRoom, key) && !nieSettings.hasOwnProperty[key]) {
                settings[key] = newsRoom[key]
              }
              if (this.isNIE && Object.prototype.hasOwnProperty.call(newsRoom, 'nie') && Object.prototype.hasOwnProperty.call(newsRoom.nie, key)) {
                nieSettings[key] = newsRoom.nie[key]
              }
            }
            if (newsRoom.products !== undefined) {
              for (let j = 0; j < newsRoom.products.length; j++) {
                var product = newsRoom.products[j]
                if (product.productName === publicationName) {
                  for (let key in settingsJson) {
                    if (Object.prototype.hasOwnProperty.call(product, key)) {
                      settings[key] = product[key]
                    }
                    if (this.isNIE && Object.prototype.hasOwnProperty.call(product, 'nie') && Object.prototype.hasOwnProperty.call(product.nie, key)) {
                      nieSettings[key] = product.nie[key]
                    }
                  }
                }
                if (product.zones !== undefined) {
                  for (var l = 0; l < product.zones.length; l++) {
                    let zone = product.zones[l]
                    if (zone.zoneName === zoneName) {
                      for (let key in settingsJson) {
                        if (Object.prototype.hasOwnProperty.call(zone, key)) {
                          settings[key] = zone[key]
                        }
                        if (this.isNIE && Object.prototype.hasOwnProperty.call(zone, 'nie') && Object.prototype.hasOwnProperty.call(zone.nie, key)) {
                          settings[key] = zone.nie[key]
                        }
                      }
                    }
                  }
                }
                if (product.issues !== undefined) {
                  for (var k = 0; k < product.issues.length; k++) {
                    var issue = product.issues[k]
                    if (issue.issueName === issueName) {
                      for (let key in settingsJson) {
                        if (Object.prototype.hasOwnProperty.call(issue, key)) {
                          settings[key] = issue[key]
                        }
                        if (this.isNIE && Object.prototype.hasOwnProperty.call(issue, 'nie') && Object.prototype.hasOwnProperty.call(issue.nie, key)) {
                          settings[key] = issue.nie[key]
                        }
                      }
                    }
                  }
                }
              }
              delete settings['products']
            }
          }
        }
        delete settings['newsRooms']
      }
      if (this.entitlements.includes('no-ads')) {
        settings.gptAdCode = ''
      }

      for (var key in nieSettings) {
        if (Object.prototype.hasOwnProperty.call(settings, key)) {
          settings[key] = nieSettings[key]
        }
      }

      this.$store.commit('setSettings', settings)

      document.body.style.backgroundColor = settings.issueViewBackgroundColor
    },
    getSettingValueFromKey(settingsJson, settingKey) {
      // returns the value for a key that matches the setting derived from publicationId.
      if (settingsJson.newsRooms !== undefined) {
        for (let i = 0; i < settingsJson.newsRooms.length; i++) {
          var newsRoom = settingsJson.newsRooms[i]
          if (newsRoom.products !== undefined) {
            for (let j = 0; j < newsRoom.products.length; j++) {
              var product = newsRoom.products[j]
              if (product.productName.toLowerCase() === this.$store.state.publicationId) {
                if (product[settingKey] !== undefined) {
                  return product[settingKey]
                } else if (newsRoom[settingKey] !== undefined) {
                  // if we cannot find the setting on product level then try news room level.
                  return newsRoom[settingKey]
                }
              }
            }
          }
        }
      }
      if (settingsJson[settingKey] !== undefined) {
        // If we can't find it on newsroom level then try top level.
        return settingsJson[settingKey]
      }
    },
    getNIESettings (settings) {
      var nieSettings = {}
      if (Object.prototype.hasOwnProperty.call(settings, 'nie')) {
        for (var key in settings.nie) {
          if (Object.prototype.hasOwnProperty.call(settings, key)) {
            nieSettings[key] = settings.nie[key]
          }
        }
      }
      return nieSettings
    },
    closeNavigations (event) {
      // Close side menu if visible
      let burgerButton = document.getElementById('burger-button')
      let slider = document.getElementById('nav-right-pages')
      if (slider !== null && slider !== undefined && slider !== event.target && burgerButton !== null && burgerButton !== undefined && burgerButton !== event.target && !slider.contains(event.target) && !burgerButton.contains(event.target)) {
        burgerButton.classList.remove('rotate-90-degree')
        slider.classList.remove('move-right')
      }

      let container = document.getElementsByClassName('scrubber')[0]
      let scrubberButton = document.getElementById('scrubberViewButton')
      const rightBarScrubberButton = document.getElementsByClassName('right-navigation-bar-item-scrubber')[0]
      // if the target of the click isn't the container or the scrubber button...
      // ... nor a descendant of the container
      if (container !== null && container !== undefined && container !== event.target && scrubberButton !== event.target && !container.contains(event.target) && rightBarScrubberButton !== event.target) {
        if (this.showScrubber) {
          container.style.display = 'none'
          this.$store.commit('toggleScrubberVisible')
        }
      }

      let cropperContainer = document.getElementsByClassName('cropper-container')[0]
      let cropButton = document.getElementById('cropMenu')
      if (event.composedPath().indexOf(cropperContainer) === -1 && event.composedPath().indexOf(cropButton) === -1 && this.showCrop && this.settings !== undefined && !this.settings.enableVerticalLayout) {
        this.$store.commit('setCropVisible', false)
      }

      const rightBarContainer = document.getElementsByClassName('right-navigation-bar-container')[0]
      if (event.composedPath().indexOf(rightBarContainer) === -1 && this.showRightAlignedNavigationBar) {
        this.$store.commit('setShowRightAlignedNavigationBar', false)
      }

      const leftScrubber = document.getElementById('left-scrubber-container')
      const leftScrubberBut = document.getElementById('left-scrubber-button-phone')
      if (leftScrubber !== null && event.composedPath().indexOf(leftScrubber) === -1 && event.composedPath().indexOf(leftScrubberBut) === -1 && leftScrubber.offsetWidth > 0) {
        this.$store.commit('setShowLeftAlignedScrubber', false)
      }

      // if (this.$store.state.showAudioPlayer && !this.showImageGalleryModal) {
      //   // Ignore clicks on audio buttons
      //   const audioButton = document.getElementsByClassName('nav-article-audio')[0]
      //   if (audioButton !== null && event.composedPath().indexOf(audioButton) !== -1) {
      //     return
      //   }
      //   const audioButton2 = document.getElementsByClassName('article-audio-icon')[0]
      //   if (audioButton2 !== null && event.composedPath().indexOf(audioButton2) !== -1) {
      //     return
      //   }
      //   const audioButton3 = document.getElementsByClassName('right-navigation-bar-item-audio')[0]
      //   if (audioButton3 !== null && event.composedPath().indexOf(audioButton3) !== -1) {
      //     return
      //   }
      //   // Also ignore click on image gallery close button.
      //   const imageGalCloseButt = document.getElementById('image-gallery-modal-close-button')
      //   if (imageGalCloseButt !== null && event.composedPath().indexOf(imageGalCloseButt) !== -1) {
      //     return
      //   }

      //   // Close the audio player when clickling outside of it.
      //   this.$store.commit('hideAudioPlayer')
      // }
    },
    navigateToArticleList () {
      if (this.isParamsValid(this.$route.params.articleNr)) {
        let articleIndex = Number(this.$route.params.articleNr)
        this.$store.commit('setCurrentArticle', this.$store.state.articles[articleIndex])
      } else {
        this.$store.commit('setCurrentArticle', this.$store.state.articles[0])
      }

      // Choose what article site to open depending on if the device is phone size or not.
      if (this.isPhone() && this.$route.name === 'articles' && !this.settings.enableVerticalLayout) {
        this.$router.push({ name: 'article-mobile', params: { articleNr: this.$route.params.articleNr } })
      } else if (!this.isPhone() && this.$route.name === 'article-mobile') {
        this.$router.push({ name: 'articles', params: { articleNr: this.$route.params.articleNr } })
      }
    },
    isParamsValid (articleParam) {
      if (articleParam.match(/\d+$/) !== null) {
        let articleNumber = Number(articleParam.match(/\d+$/)[0])
        if (articleNumber <= this.$store.state.articles.length) {
          return true
        }
      }
      return false
    },
    preventBounce (event) {
      // Block touch events for pages if the touch event is not a zooming event
      if (this.$route.name === 'pages' && event.scale === 1 && event.rotation === 0 && !this.showIssueOverview) {
        // event.preventDefault()
      }
    },
    createTrackingModule (trackingConfig) {
      let trackingModule
      switch (trackingConfig.module) {
        // case 'GATrackingModule':
        //   trackingModule = new GATrackingModule(this.$store, this.$router, trackingConfig.config)
        //   break
        case 'GTMTrackingModule':
          trackingModule = new GTMTrackingModule(this.$store, trackingConfig.config)
          break
        case 'WindowTrackingModule':
          trackingModule = new WindowTrackingModule(this.$store, trackingConfig.config)
          break;
        case 'FirebaseTrackingModule':
          trackingModule = new FirebaseTrackingModule(this.$store, trackingConfig.config)
          break;
        default:
          console.log('Unknown tracking module: ' + trackingConfig.module)
          trackingModule = null
          break
      }
      return trackingModule
    },
    loadSettingsForTrackingTest (settingsPath) {
      this.$http.get(settingsPath).then((response) => {
        return response.json()
      }).then((json) => {
        this.parseSettings(json)
        if (this.settings.tracking && this.settings.tracking.modules) {
          let modules = this.settings.tracking.modules
          for (var i = 0; i < modules.length; i++) {
            if (modules[i].module) {
              const trackingModule = this.createTrackingModule(modules[i])
              if (trackingModule) {
                Vue.cciEventTrackingPlugin.setEventTrackingModule(trackingModule)
              }
            }
          }
        }
      }).catch((response) => {
        console.log('ERROR', response)
        this.$router.push({ name: 'error' })
      })
    },
    parseEntitlementsHeader(pubs) {
      var pubsJson = JSON.parse(pubs)
      for (var key in pubsJson) {
        if (Object.prototype.hasOwnProperty.call(pubsJson, key)) {
          if (key.toLowerCase().indexOf(this.$store.state.publicationId) !== -1) {
            // console.log('entitlements: ' + pubsJson[key])
            this.$store.state.entitlements = pubsJson[key]
            break
          }
        }
      }
    },
    getIndexForPageFromRouteParam(pageParam) {
      for (var i = 0; i < this.$store.state.pages.length; i++) {
        if (this.$store.state.pages[i].firstPage.pageNumber === pageParam) {
          return i
        } else if (this.$store.state.pages[i].secondPage !== null && this.$store.state.pages[i].secondPage.pageNumber === pageParam) {
          return i
        }
      }
    },
    setFontSizeFromStylesheet() {
      if (stylesheetRef !== undefined) {
        let stylesheetUrl = this.opsUrl + stylesheetRef
        this.$http.get(stylesheetUrl).then((response) => {
          return response.text()
        }).then((cssdata) => {
          // console.log(cssdata)
          var doc = document.implementation.createHTMLDocument(""),
          styleElement = document.createElement("style")

          styleElement.textContent = cssdata
          // the style will only be parsed once it is added to a document
          doc.body.appendChild(styleElement)
          let rules = styleElement.sheet.cssRules
          for (var i = 0; i < rules.length; i++) {
            if (rules[i].selectorText === 'html') {
              let fontSizeStr = rules[i].style.fontSize
              let fontSize = fontSizeStr.match(/\d+/)[0]
              this.$store.state.articleFontsize = Number(fontSize)
              this.$store.state.articleFontSizeUnit = fontSizeStr.replace(fontSize, '')
              break
            }

          }
          // console.log(styleElement.sheet.cssRules)
        }).catch((response) => {
          console.log('Stylesheet ERROR', response)
        })
      }
    },
    orientationDidChange () {
      if (this.$route.name === 'article-mobile' || this.$route.name === 'articles-mobile') {
        let articleNumber = this.$store.state.articles.indexOf(this.currentArticle).toString()
        this.$router.push({
          name: 'articles',
          params: { articleNr: articleNumber }
        })
      } else if (this.$route.name === 'articles') {
        this.$router.push({
          name: 'articles-mobile'
        })
      }
    },
    pageChildObj () {
      if (this.$route.name !== "pages") {
        return this.$store.state.currentArticle
      }
      return this.$store.state.selectedPageChild
    }
  },
  beforeDestroy () {
    window.removeEventListener('orientationchange', this.orientationDidChange)
  },
  components: {
    CciNavigationBar,
    CciSectionsBar,
    CciIssueOverview,
    CciArticleModal,
    CciSocialSharing,
    CciScrubber,
    CciGoogleAdBottomMobile,
    CciGoogleAdSide,
    CciImageGalleryModal,
    CciRightAlignedNavigationBar,
    CciLeftAlignedScrubber
  }
}
